import { toSearchParams } from '@/lib/format';
import { maintenanceCustomerPath } from '@/products/maintenance/maintenance-paths';

export function maintenanceCustomerProjectsPath(
  customerId: string,
  patch: { page?: number } = {},
): string {
  return `${maintenanceCustomerPath(customerId)}${toSearchParams({ page: patch.page })}`;
}

export function maintenanceCustomerProjectsPageFromSearch(search: string): number {
  const page = new URLSearchParams(search).get('page');
  return page ? Math.max(1, Number(page) || 1) : 1;
}
